import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ChangeEventHandler } from "react";

import { IconProp } from "@fortawesome/fontawesome-svg-core";

import common from "./barInput.module.scss";

interface BarProps {
  id: string;
  label: string;
  type?: string;

  maxLength?: number;
  placeholder: string;
  cb: ChangeEventHandler<HTMLInputElement>;
  value: string;
  icon: IconProp;
  autoComplete?: string;
  disabled?: boolean;
}

export default function BarInput(props: BarProps) {
  const { id, label, type, maxLength, placeholder, cb, value, icon, autoComplete, disabled } = props;

  return (
    <div className={common.field}>
      <label className={common.label} htmlFor={id}>{label}</label>
      <div className={common.barInput}>
        <div className={common.iconWrap} aria-hidden='true'>
          <FontAwesomeIcon icon={icon} size='1x' />
        </div>
        <input
          id={id}
          name={id}
          type={type}
          value={value}
          placeholder={placeholder}
          onChange={cb}
          maxLength={maxLength}
          autoComplete={autoComplete}
          disabled={disabled}
          required
        />
      </div>
    </div>
  );
}
